<script setup lang="ts">
definePageMeta({
  layout: 'landing',
  smoothScroll: true,
})

const { t } = useI18n()

useHead({
  titleTemplate: (chunk) => chunk || 'bookforme',
  title: () => seoTitle(t, 'page.home.page_title', 'Take charge of your work. Save time without stress.'),
  meta: [
    { name: 'description', content: 'bookforme is your all-in-one solution for appointment scheduling and business management, designed for salons, spas, clinics, and any service-based business.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: () => seoTitle(t, 'page.home.page_title', 'Take charge of your work. Save time without stress.') },
    { property: 'og:description', content: 'bookforme manages appointments, deposits, and availability—so you can focus on your craft.' },
    { property: 'og:site_name', content: 'bookforme' },
    { name: 'twitter:card', content: 'summary_large_image' },
  ],
})
</script>

<template>
  <div>
    <LandingHero />
    <LandingOnePlatform />
    <LandingFeatures />
    <LandingHowItWorks />
    <LandingWhyBookforme />
    <LandingFaq />
  </div>
</template>
